import Navbar from "@/components/Navbar";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { ArrowLeft, FileText, Download } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

const VisualizationRendering = () => {
  const navigate = useNavigate();
  
  const handleViewDetails = (title: string) => {
    navigate(`/agency-solutions?search=${encodeURIComponent(title)}`);
  };

  const knowledgeBases = [
    {
      title: "3D Modeling & Visualization: Realistic Virtual Models",
      description: "Advanced 3D modeling and visualization tools for creating realistic virtual models of federal building projects",
      type: "3D Tool",
      lastUpdated: "2024-01-24"
    },
    {
      title: "Style Transfer & Concept Art: Space Visualization",
      description: "AI-powered style transfer and concept art tools for visualizing federal space designs and concepts",
      type: "AI Tool",
      lastUpdated: "2024-02-14"
    },
    {
      title: "Furniture & Space Layout Rendering",
      description: "Specialized rendering tools for furniture placement and space layout visualization in federal facilities",
      type: "Rendering Tool",
      lastUpdated: "2024-01-30"
    },
    {
      title: "Concept Renderings & Mood Boards",
      description: "Tools and frameworks for creating concept renderings and mood boards for federal building design projects",
      type: "Design Tool",
      lastUpdated: "2024-02-08"
    }
  ];

  return (
    <div className="min-h-screen bg-muted">
      <Navbar />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="mb-6">
          <Link to="/gsa-channel" className="inline-flex items-center text-primary hover:text-primary/80 mb-4">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to GSA Channel
          </Link>
          <h1 className="text-3xl font-bold mb-2">Visualization & Rendering</h1>
          <p className="text-muted-foreground">
            Advanced visualization and rendering tools for 3D modeling, concept art, space layout visualization, and design presentation in federal projects.
          </p>
        </div>

        <div className="grid gap-6">
          {knowledgeBases.map((kb, index) => (
            <Card key={index} className="hover:shadow-lg transition-shadow">
              <CardHeader>
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <CardTitle className="text-xl mb-2">{kb.title}</CardTitle>
                    <p className="text-muted-foreground">{kb.description}</p>
                  </div>
                  <div className="flex flex-col items-end gap-2">
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-teal-100 text-teal-800">
                      {kb.type}
                    </span>
                    <span className="text-xs text-muted-foreground">
                      Updated: {kb.lastUpdated}
                    </span>
                  </div>
                </div>
              </CardHeader>
              <CardContent>
                <div className="flex gap-3">
                  <Button variant="outline" size="sm" onClick={() => handleViewDetails(kb.title)}>
                    <FileText className="h-4 w-4 mr-2" />
                    View Details
                  </Button>
                  <Button variant="outline" size="sm">
                    <Download className="h-4 w-4 mr-2" />
                    Download
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </main>
    </div>
  );
};

export default VisualizationRendering;